<template>
  <div>
    <template
      class="comment-total-list"
      v-for="(item, index) in List"
    >
      <div
        :key="`${item.id}comment-card`"
        class="comment-card"
      >
        <div class="comment-card-div">
          <div
            class="comment-user"
            :style="
        item.avatar
          ? { 'background-image': `url(${item.avatar})` }
          : { 'background-image': `url(${defaultAvatar()})` }
      "
          ></div>
          <div class="comment-content">
            <div class="comment-content-basic">
              <span
                class="comment-author"
                v-text="item.nickName?item.nickName:`用户${item.userId}`"
              ></span>
              <span
                class="comment-time"
                v-text="item.updateTime.substring(0, item.updateTime.length - 3)"
              ></span>
            </div>
            <p
              class="comment-content-detail"
              v-text="item.comment"
            ></p>
          </div>
          <comment-operation
            :isreply="item.isreply"
            :ishot="item.ishot"
            :isLike="Boolean(item.ownAdoptFlag)"
            :item="item"
            :index="index"
            :likeNumber="item.adoptNum"
            @reply="reply(index,item.isreply,item.ishot)"
            @commentDelete="commentDelete(item,index)"
            @toggleLike="toggleLike(item,index)"
          ></comment-operation>
        </div>
        <comment-content
          :isreply="item.isreply"
          :ishot="item.ishot"
          :item="item"
          :contents="item"
          :comment="comment"
          :contentStyle="contentStyle"
          @commentContent="commentContent"
          @replyRelease="replyRelease('1级',item,index)"
        ></comment-content>
        <div class="commont-reply-interactive">
          <template v-for="(childitem,childindex) in item.replys">
            <div class="commont-reply-interactive-item">
              <div
                class="comment-user-interactive"
                :style="
        childitem.avatar
          ? { 'background-image': `url(${childitem.avatar})` }
          : { 'background-image': `url(${defaultAvatar()})` }"
              ></div>
              <div class="comment-content-interactive">
                <div class="comment-content-basic-interactive">
                  <span
                    class="comment-author-interactive"
                    v-text="childitem.nickName?childitem.nickName:`用户${childitem.userId}`"
                  ></span>
                  <span class="comment-author-interactive">回复</span>
                  <span
                    class="comment-author-interactive"
                    v-text="childitem.replyNickName?childitem.replyNickName:`用户${childitem.replyUserId}`"
                  ></span>
                  <span
                    class="comment-time-interactive"
                    v-text="childitem.createTime"
                  ></span>
                </div>
                <p
                  class="comment-content-detail-interactive"
                  v-text="childitem.comment"
                ></p>
              </div>
              <comment-operation
                :isreply="childitem.isreply"
                :ishot="childitem.ishot"
                :isLike="Boolean(childitem.ownAdoptFlag)"
                :item="childitem"
                :index="index"
                :childindex="childindex"
                :likeNumber="childitem.likeNumber"
                @reply="reply(index,childitem.isreply,childitem.ishot,childindex)"
                @commentDelete="commentDelete(childitem,index,childindex)"
                @toggleLike="toggleLike(childitem,index,childindex)"
              ></comment-operation>
            </div>
            <comment-content
              :isreply="childitem.isreply"
              :ishot="childitem.ishot"
              :contents="childitem"
              :comment="comment"
              :childindex="childindex"
              @commentContent="commentContent"
              @replyRelease="replyRelease('2级',childitem,index,childindex)"
            ></comment-content>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import targetUrl from "@/assets/images/travel/new-target.png";
import CommentContent from "./CommentContent";
import CommentOperation from "./CommentOperation";
export default {
  data() {
    return {
      comment: "",
      contentStyle: "margin-left:60px"
    };
  },
  components: {
    CommentContent,
    CommentOperation
  },
  props: {
    //当前评论对象
    List: {
      type: Array
    }
  },
  created() {},
  methods: {
    toggleLike(item, index, childindex) {
      this.$emit("toggleLike", {
        item: item,
        index: index,
        childindex: childindex
      });
    },
    defaultAvatar() {
      return import("@/assets/images/person/avatar-default.png");
    },
    commentDelete(item, index, childindex) {
      this.$emit("commentDelete", {
        item: item,
        index: index,
        childindex: childindex
      });
    },
    reply(index, isreply, ishot, childindex) {
      this.$emit("isreply", {
        index: index,
        isreply: isreply,
        ishot: ishot,
        childindex: childindex
      });
    },
    commentContent(comment) {
      this.comment = comment;
    },
    replyRelease(flag, contents, index, childindex) {
      let details = {
        flag: flag,
        contents: contents,
        index: index,
        childindex: childindex,
        comment: this.comment,
        replyId: contents.id,
        userId: contents.userId
      };
      this.$emit("replyRelease", details);
    }
  }
};
</script>
<style lang="less">
.comment-card {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 30px;
  .comment-card-div {
    display: flex;
    min-height: 94px;
  }
  .commont-reply-interactive {
    margin-left: 60px;
    display: flex;
    flex-direction: column;
    .commont-reply-interactive-item {
      display: flex;
    }
    .comment-user-interactive {
      width: 51px;
      height: 51px;
      border-radius: 30px;
      background-size: 100% 100%;
      background-image: url(/img/avatar-default.107ab921.png);
      flex-shrink: 0;
    }
    .comment-content-interactive {
      //占据去掉头像和点赞之后的所有剩余空间
      flex-grow: 1;
      padding-left: 20px;
      .comment-content-basic-interactive {
        display: flex;
        .comment-author,
        .comment-time-interactive {
          color: #abb2bb;
          align-self: center;
        }
        .comment-author-interactive {
          margin-right: 10px;
        }
        .comment-author-interactive:nth-child(1) {
          max-width: 147px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .comment-author-interactive:nth-child(3) {
          max-width: 147px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .comment-author-interactive:nth-child(2) {
          margin-right: 10px;
          color: #abb2bb;
        }
        .comment-time-interactive {
        }
      }
      .comment-content-detail-interactive {
        text-align-last: left;
        //换行
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
      }
      .comment-content-detail {
        white-space: pre-wrap;
        color: #555555;
        //设置段落的最后一行的对齐方式为左对齐
        text-align-last: left;
        //换行
        word-wrap: break-word;
        word-break: break-all;
        overflow: hidden;
      }
    }
  }
  /* 评论用户头像部分 */
  .comment-user {
    width: 60px;
    height: 60px;
    border-radius: 30px;
    background-size: 100% 100%;
    //默认背景
    background-image: url("~@/assets/images/travel/avatar-default.png");
    // 空间不足的时候不做压缩
    flex-shrink: 0;
  }
  /* 评论内容部分 */
  .comment-content {
    //占据去掉头像和点赞之后的所有剩余空间
    flex-grow: 1;
    padding-left: 20px;
    .comment-content-basic {
      display: flex;
      .comment-author,
      .comment-time {
        color: #abb2bb;
        align-self: center;
      }
      .comment-author {
        margin-right: 20px;
      }
      .comment-time {
      }
    }
    .comment-content-detail {
      white-space: pre-wrap;
      color: #555555;
      //设置段落的最后一行的对齐方式为左对齐
      text-align-last: left;
      word-wrap: break-word;
      word-break: break-all;
      overflow: hidden;
    }
  }
  .comment-operation {
    min-width: 160px;
    display: flex;
    div {
      flex-grow: 1;
    }
  }
  .comment-delete {
    display: flex;
    flex-direction: column;
    .iconshanchu {
      cursor: pointer;
      font-size: 19px;
    }
    .delete-font {
      font-size: 12px;
    }
  }
  .comment-reply {
    display: flex;
    flex-direction: column;
    .reply-like-icon {
      cursor: pointer;
      font-size: 19px;
    }
    .reply-font {
      font-size: 12px;
    }
  }
  /* 点赞和点赞文字部分 */
  .comment-like {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    .comment-like-icon {
      cursor: pointer;
      font-size: 20px;
    }
    .comment-like-number {
      font-size: 14px;
    }
    .number-yizan {
      color: #57dec1;
    }
    .number-zan {
      color: #666666;
    }
    .iconyizan,
    .iconzan {
      color: #57dec1;
    }
  }
}
.comment-reply-content {
  display: flex;
  -ms-flex-pack: justify;
  flex-direction: column;
  .comment-reply-content-item {
    display: flex;
  }
  /* 评论用户头像部分 */
  .comment-user {
    width: 51px;
    height: 51px;
    border-radius: 30px;
    background-size: 100% 100%;
    //默认背景
    background-image: url("~@/assets/images/travel/avatar-default.png");
    // 空间不足的时候不做压缩
    flex-shrink: 0;
  }
  .comment-reply-input.el-textarea {
    margin-left: 20px;
    textarea {
      height: 98px;
    }
  }
  .comment-reply-release {
    .comment-reply-release-button {
      width: 148px;
      height: 42px;
      background-color: #57dec1;
      border-radius: 4px;
      float: right;
      margin-top: 13px;
      margin-bottom: 13px;
      color: #ffffff;
    }
  }
}
</style>
